export default __webpack_public_path__ + "static/media/envelop.84bbe32f.svg";